import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-floating-banner',
  templateUrl: './floating-banner.component.html',
  styleUrls: ['./floating-banner.component.scss'],
})
export class FloatingBannerComponent {
  @Input() messageKey!: string;
  @Input() svgIcon: string = 'ph-regular-check-circle';
  @Output() dismissed = new EventEmitter<void>();
}
